import { Box, Typography } from '@mui/material';
import React from 'react';
import { useForm } from 'react-hook-form';

import ControlledNumberField from '~components/Form/ControlledNumberField';
import { ParameterDelay } from '~pages/SipConfiguration/domain';

import { ContactFlowNodeProps } from '..';
import BaseNode from '../BaseNode';

export default function DelayNode(props: ContactFlowNodeProps) {
  const form = useForm<ParameterDelay>({
    defaultValues: props.data.parameter.delay,
  });

  return (
    <BaseNode
      {...props}
      title='Delay'
      parameterForm={form}
      renderParameterForm={(delay) => <Typography>Delay (ms): {delay?.delayMS ?? '--'}</Typography>}
      transformParameter={(delay) => ({ delay })}
      renderEditParameter={({ control }) => (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
          }}>
          <ControlledNumberField name='delayMS' control={control} label='Delay (ms)' defaultValue='' />
        </Box>
      )}
    />
  );
}
